import { apolloClientPrivate } from '../graphql/apolloClient'
import { showModal, hideModal } from '../components/common/modal/ModalService'
import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import React, { useEffect } from 'react'

import { SetMyTimezoneDocument } from './checkUsersTimezone.codegen'
import { usePublicApiSession } from '../public-api/hooks/usePublicApiSession'
import { Trans } from '@lingui/macro'
import dayjs from 'shared/dayjs'

const optOutLocalStorageKey = 'timezoneCheck'

export const CheckUsersTimezone = () => {
  const { session } = usePublicApiSession()

  const timezoneGuess = dayjs.tz.guess()
  const patchUsersTimezone = () =>
    apolloClientPrivate.mutate({
      mutation: SetMyTimezoneDocument,
      variables: { input: { timezone: timezoneGuess } }
    })

  useEffect(() => {
    const user = session?.user
    if (!user) {
      return
    }
    if (!user.timezone) {
      patchUsersTimezone()
    } else {
      const optOut = localStorage?.getItem(optOutLocalStorageKey)

      if (timezoneGuess !== user.timezone && optOut !== 'false') {
        showModal({
          header: <Trans>Update your timezone?</Trans>,
          children: (
            <p>
              <Trans>
                Your looop timezone is set to {user.timezone}, but it seems
                you're currently in {timezoneGuess}. <br />
              </Trans>

              <br />
              <Trans>Would you like us to update your timezone for you ?</Trans>
            </p>
          ),
          controls: (
            <div>
              <ButtonClean
                onClick={() => {
                  localStorage.setItem(optOutLocalStorageKey, 'false')
                  hideModal()
                }}
              >
                <Trans>No thanks</Trans>
              </ButtonClean>
              <ButtonPrimary
                onClick={async () => {
                  await patchUsersTimezone()

                  hideModal()
                }}
              >
                <Trans>Update</Trans>
              </ButtonPrimary>
            </div>
          )
        })
      }
    }
  }, [session])

  return null
}
